<template>
  <v-dialog width="350px" v-model="showDialog" persistent>
    <v-card v-if="showDialog && inviteVisible">
      <v-img :height="200" width="100%" src="/assets/images/bg-invite-friend.svg"></v-img>
      <v-card-text>
        <div class="title text-xs-center body-2">{{ $t('referral_code.title') }}</div>
        <div class="text-xs-center">
          <div class="grey--text py-2">{{ $t('referral_code.des') }}</div>
        </div>
      </v-card-text>
      <v-card-actions class="pr-3 pb-3">
        <v-spacer></v-spacer>
        <v-btn flat small @click="close">{{ $t('referral_code.invite_late') }}</v-btn>
        <!-- <v-btn flat small>{{$t('referral_code.invite_not_show')}}</v-btn> -->
        <v-btn @click="invite" flat small class="accent--text">{{
          $t('referral_code.invite')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { getItemStorage, setItemStorage } from '@/plugins/util'
const SHOWN_INVITE_KEY = 'shown_invite_popup'
const COUNT_ORDERS = 10
export default {
  data() {
    return {
      showDialog: false,
      inviteVisible: false
    }
  },
  methods: {
    close() {
      this.showDialog = false
      setItemStorage(SHOWN_INVITE_KEY, true)
    },
    invite() {
      this.close()
      this.$router.push({ name: 'invite' })
    },
    loadOrders() {
      const params = {
        offset: 0,
        count: COUNT_ORDERS + 1,
        timeout: 20000,
        fields: ['_id', 'status'].join(','),
        status: this.$constants.ORDER_STATUS.COMPLETED,
        token: this.$store.getters.token
      }
      const api = process.env.VUE_APP_API_URL.concat(this.$constants.API.order.list)
      this.axios(api, { params: params })
        .then((response) => {
          if (response && response.data) {
            const numOrder = response.data.length
            if (numOrder === COUNT_ORDERS) {
              this.inviteVisible = true
              this.showDialog = true
            } else if (numOrder > COUNT_ORDERS) {
              setItemStorage(SHOWN_INVITE_KEY, true)
            }
          }
        })
        .catch(() => {})
    }
  },
  beforeMount() {
    const shownInviteBefore = getItemStorage(SHOWN_INVITE_KEY)
    if (!shownInviteBefore) {
      this.loadOrders()
    }
  }
}
</script>
